import { PageBackButton } from '@/components/PageBackButton';
import './page-back.css';

export const PublicBackFrame = ({ children }) => <div className="public-back-frame">
  <nav className="public-back-toolbar" aria-label="Paginanavigatie" data-testid="public-back-toolbar">
    <PageBackButton testId="page-back-public" />
  </nav>
  <div className="public-back-content">{children}</div>
</div>;